import { render, staticRenderFns } from "./TotalSummary.vue?vue&type=template&id=5c97da40"
import script from "./TotalSummary.vue?vue&type=script&lang=js"
export * from "./TotalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports